import { useDialog } from "../../../../../shared/components/feedback/dialog";
import { SALE_REOPEN_REQUEST_RESULT } from "../config/sale-reopen-request-modal.config.js";
import { useSaleReopenRequestForm } from "../hooks/use-sale-reopen-request-form.js";
import { SaleReopenRequestModal } from "./sale-reopen-request-modal.js";

/**
 * Feature Logic: orquestra hook de solicitação + modal + feedback via useDialog.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {string|number|null} props.saleId
 * @param {() => void} props.onClose
 */
export function SaleReopenRequestDialog({ open, saleId, onClose }) {
  const dialog = useDialog();
  const resultCopy = SALE_REOPEN_REQUEST_RESULT;

  const {
    form,
    options,
    optionsLoading,
    optionsError,
    reloadOptions,
    onSubmit,
    isSubmitting,
    canSubmit,
  } = useSaleReopenRequestForm({
    idsale: saleId,
    open,
    onSuccess: (response) => {
      onClose?.();
      dialog.openDialog({
        title: resultCopy.successTitle,
        message: response?.message || resultCopy.successMessage,
        status: "success",
      });
    },
    onError: (response) => {
      dialog.openDialog({
        title: resultCopy.errorTitle,
        message: response?.message || resultCopy.errorMessage,
        status: "error",
      });
    },
  });

  return (
    <SaleReopenRequestModal
      open={open}
      onClose={onClose}
      form={form}
      options={options}
      optionsLoading={optionsLoading}
      optionsError={optionsError}
      onReloadOptions={reloadOptions}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      canSubmit={canSubmit}
    />
  );
}
